import { render, staticRenderFns } from "./CostTabs.vue?vue&type=template&id=ac84a0b6"
import script from "./CostTabs.vue?vue&type=script&lang=js"
export * from "./CostTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports